import { ChangeDetectionStrategy, Component, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { TooltipModule } from '@libs/ui-lib';
import { selectIsEaglesoftPms } from '@libs/store';
import { HealthHistoryDialogService } from '../../health-history-dialog.service';
import { PatientAlertsItemComponent } from '../patient-alerts-item/patient-alerts-item.component';
import { PatientAlertsItemSaveData } from '../patient-alerts-item-edit/patient-alerts-item-edit.component';
import { PatientAlertsTabService } from './patient-alerts-tab.service';

@Component({
  selector: 'lib-patient-alerts-tab',
  standalone: true,
  imports: [CommonModule, TranslateModule, SvgIconComponent, TooltipModule, LottieComponent, PatientAlertsItemComponent],
  templateUrl: './patient-alerts-tab.component.html',
  styleUrl: './patient-alerts-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PatientAlertsTabService],
})
export class PatientAlertsTabComponent implements OnInit, OnDestroy {
  private readonly patientAlertsTabService = inject(PatientAlertsTabService);
  private readonly healthHistoryDialogService = inject(HealthHistoryDialogService);
  private readonly store = inject(Store);

  protected readonly isEaglesoftPms = this.store.selectSignal(selectIsEaglesoftPms);

  public readonly patientAlerts = this.patientAlertsTabService.patientAlerts;
  public readonly isLoading = this.patientAlertsTabService.isLoading;
  public readonly editedPatientAlertsItemId = this.patientAlertsTabService.editedPatientAlertsItemId;
  public readonly newPatientAlertsItem = this.patientAlertsTabService.newPatientAlertsItem;

  // Feature flags from parent dialog service
  public readonly addPatientAlertEnabled = this.healthHistoryDialogService.addPatientAlertEnabled;
  public readonly editPatientAlertEnabled = this.healthHistoryDialogService.editPatientAlertEnabled;
  public readonly deletePatientAlertEnabled = this.healthHistoryDialogService.deletePatientAlertEnabled;

  public readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };

  public ngOnInit(): void {
    this.patientAlertsTabService.init();
  }

  public onChangeEditMode(event: { editMode: boolean; itemId: string }): void {
    this.patientAlertsTabService.setEditMode(event.editMode ? event.itemId : null);
  }

  public onDeleteItem(event: string): void {
    this.patientAlertsTabService.deletePatientAlertsItem(event);
  }

  public onSaveItem(event: PatientAlertsItemSaveData): void {
    this.patientAlertsTabService.editPatientAlertsItem(event);
  }

  public onAddNewItem(): void {
    this.patientAlertsTabService.addNewPatientAlertsItem();
  }

  public onDiscardNewItem(): void {
    this.patientAlertsTabService.discardNewNewPatientAlertsItem();
  }

  public ngOnDestroy(): void {
    this.patientAlertsTabService.setEditMode(null);
  }
}
